{
  "chart": {
    "how-to-measure": "How to measure",
    "select-your-size-we-ll-notify-you-once-it-s-back-in-stock": "Select your size we’ll notify you once it’s back in stock",
    "image-nav-previous": "Previous image",
    "image-nav-next": "Next image",
    "image-nav-position": "{{current}} / {{total}}"
  },
  "page": {
    "plans": {
      "try-now": "Try now",
      "what-included": "What's included?",
      "popular-plan": "Popular"
    },
    "about-us": {
      "title": "About us",
      "intro": "Goodchart was born in 2023 with a mission to transform your clothes shopping experience. Our team of fashion enthusiasts, designers, and tech experts is here to empower you in finding clothes that truly complement your body. With our user-friendly interface and advanced algorithms, we provide personalised recommendations based on your measurements, style, and lifestyle.",
      "community": "Say goodbye to compromise and hello to confidence and comfort. Join our inclusive community of satisfied customers and embark on a joyful shopping journey with Goodchart.",
      "tagline": "Unleash your style. Experience pure fashion euphoria.",
      "founders": "Founders",
      "cedric-photo-alt": "Cedric, Goodchart Co-founder and Head of Product",
      "nick-photo-alt": "Nick, Goodchart Co-founder and Operation Director",
      "quentin-photo-alt": "Quentin, Goodchart Head Of Information Technology",
      "cedric": "Cedric",
      "cedric-role": "Goodchart Co-founder and Head of Product",
      "nick": "Nick",
      "nick-role": "Goodchart Co-founder and Operation Director",
      "quentin": "Quentin",
      "quentin-role": "Goodchart Head Of Information Technology"
    },
    "contact": {
      "title": "Contact us",
      "lets-talk": "Let's talk",
      "subtitle": "Complete the form and our team will be in touch via email.",
      "first-name": "First name",
      "first-name-required": "First name is required",
      "last-name": "Last name",
      "last-name-required": "Last name is required",
      "email": "Email",
      "email-required": "Email is required",
      "email-invalid": "Please enter a valid email address",
      "message": "Message",
      "message-required": "Message is required",
      "sending": "Sending...",
      "send": "Send",
      "success": "Your form has been sent to our team!"
    },
    "email-unsubscribe": {
      "title": "Email subscription",
      "unsubscribe-confirm": "Are you sure you want to unsubscribe from our mailing list?",
      "unsubscribe-info": "By unsubscribing, you will no longer receive updates, newsletters, and special offers from us.",
      "cancel": "Cancel",
      "confirm-unsubscription": "Confirm unsubscription",
      "resubscribe-confirm": "Would you like to re-subscribe to our mailing list?",
      "resubscribe-info": "Stay updated with our latest news, exclusive offers, and exciting updates.",
      "resubscribe": "Re-subscribe",
      "unsubscribe-success": "Successfully unsubscribing your email",
      "unsubscribe-error": "There was an issue unsubscribing your email",
      "resubscribe-success": "Successfully resubscribing your email",
      "resubscribe-error": "There was an issue resubscribing your email"
    },
    "back-to-stock": {
      "notify-me-product": "Notify me for product {{title}} - {{variant}}"
    },
    "help": {
      "title": "Help Center",
      "description": "Guides to setting up and using Goodchart on your Shopify store.",
      "search": "Search help articles",
      "loading": "Loading…",
      "load-failed": "The help center couldn't be loaded. Please try again in a moment.",
      "no-results": "No articles match your search.",
      "no-articles": "There are no help articles yet.",
      "topics": {
        "getting-started": "Getting started",
        "size-charts": "Size charts",
        "table-charts": "Table charts",
        "assigning-products": "Assigning products",
        "storefront-display": "Storefront display",
        "chart-import": "Chart import",
        "size-recommendations": "Size recommendations",
        "plans-billing": "Plans & billing",
        "troubleshooting": "Troubleshooting"
      },
      "back": "Back to help center",
      "browse": "Browse the help center",
      "not-found": {
        "title": "Article not found",
        "description": "This article doesn't exist or is no longer available."
      },
      "updated": "Last updated {{date}}",
      "related": "More in {{topic}}",
      "contact": {
        "title": "Still need help?",
        "description": "Send us a message and our team will get back to you by email. If you have the Goodchart app installed, you can also ask in its support chat.",
        "link": "Contact us"
      },
      "article-load-failed": "This article couldn't be loaded. Please try again in a moment."
    }
  },
  "error": {
    "error-occurred": "Error occurred!",
    "failed-to-subscribe-to-this-product": "Failed to subscribe to this product!",
    "failed-to-get-your-size-recommendation-please-try-again-later": "Failed to get your size recommendation. Please try again later."
  },
  "common": {
    "close": "Close"
  },
  "component": {
    "size-recommender": {
      "form": {
        "title": "Find your best size",
        "subtitle": "A few quick details for a better fit",
        "shopping-for": "SHOPPING FOR",
        "gender-women": "Women",
        "gender-men": "Men",
        "gender-other": "Other",
        "measurements": "MEASUREMENTS",
        "height": "Height",
        "height-required": "Height is required",
        "height-min": "Min height is 1",
        "weight": "Weight",
        "weight-required": "Weight is required",
        "weight-min": "Min weight is 1",
        "preferred-fit": "Preferred fit",
        "continue": "Continue"
      },
      "result": {
        "suggested-size": "Suggested Size:",
        "no-fit": "Unfortunately, it seems we don't have an ideal size at the moment. We recommend checking back later for more options.",
        "verdict": "Verdict:",
        "similar-variants": "Similar variants:",
        "proceed": "Proceed with this variant",
        "estimate-disclaimer": "(Estimate based on brand and user info, results may vary.)",
        "back": "Back"
      }
    },
    "footer": {
      "terms": "Terms",
      "privacy": "Privacy",
      "help-center": "Help Center",
      "blog": "Blog",
      "about": "About",
      "contact-us": "Contact Us"
    },
    "conversion-table": {
      "description": "Depending on the fit, slight differences in measurement may appear. Find your correct size in the chart below.",
      "size": "Size"
    },
    "add-to-cart-btn": {
      "notify-me-when-available": "Notify me when available",
      "notify-me": "Notify me",
      "out-of-stock": "Out of stock"
    },
    "restock-form": {
      "your-name": "Your Name",
      "your-email": "Your Email Address",
      "email-required": "Email is required",
      "subscribing": "Subscribing...",
      "notify-me": "NOTIFY ME",
      "agree-terms": "By continuing, you agree to our",
      "terms-privacy": "Term & Privacy policy",
      "news-opt-in": "I would like to receive updates about new launches and other inspirational content (optional)"
    },
    "back-to-stock-result": {
      "new-subscription": "Thank you, we will email you when size <span class=\"font-bold\">{{name}}</span> is available.",
      "existing-subscription": "We've got your email! We'll let you know as soon as the size <span class=\"font-bold\">{{name}}</span> is restocked.",
      "back-to-collection": "Back to Collection"
    },
    "chart": {
      "find-your-size": "Find your size",
      "size-guide": "Size Guide",
      "recommendation": "Recommendation",
      "body-measurements": "BODY MEASUREMENTS",
      "model-measurements": "MODEL MEASUREMENTS",
      "model-description": "Model {{name}} is {{height}}cm and wears size {{variant}}.",
      "size-conversion": "SIZE CONVERSION"
    },
    "landing": {
      "learn": "Learn",
      "learn-more": "Learn more",
      "blog": "Blog",
      "blog-description": "Explore the latest announcements, product updates, and more",
      "help-center": "Help Center",
      "help-center-description": "Getting started, how-to-articles, and step-by-step instructions",
      "demo": "Demo",
      "demo-description": "See Goodsize widgets in action on our example store",
      "services": "SERVICES",
      "contact": "Contact",
      "privacy": "Privacy",
      "goodsize": "Goodsize",
      "goodsize-description": "Discover our Fitting solution for your business",
      "goodchart": "Goodchart",
      "goodchart-description": "Visual size chart to boost conversion"
    },
    "product-variant-completer": {
      "title": "Choose your options",
      "body": "Select your {{option}} to continue.",
      "body-multiple": "Select the remaining options to continue.",
      "body-notify": "Which {{option}} should we watch for you?",
      "confirm": "Continue",
      "cancel": "Cancel",
      "empty": "This combination isn't available."
    },
    "checkout-variant": {
      "label": "You are checking out {{variant}}",
      "aria-label": "Change the variant you are checking out",
      "sold-out": "sold out"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday"
    }
  }
}
